import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentPreviewCard = ({ title, description, icon, category, estimatedTime, locked = true }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:border-primary/30 transition-all duration-200 relative overflow-hidden group">
      {locked && (
        <div className="absolute top-3 right-3 w-8 h-8 bg-muted/50 rounded-full flex items-center justify-center">
          <Icon name="Lock" size={16} color="var(--color-muted-foreground)" />
        </div>
      )}
      
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors duration-200">
          <Icon name={icon} size={24} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
        <span className="text-xs font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">
          {category}
        </span>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
          <span>{estimatedTime}</span>
        </div>
      </div>
    </div>
  );
};

export default ContentPreviewCard;